import React, { useEffect, useRef, useState } from 'react';

import { toast } from 'react-toastify';

import { useNavigate } from 'react-router-dom';

import { Input, BackButton, Button, TextLink } from '../shared/ui';
import { useLoginMutation } from '../services/auth.api';
import { checkEmailMask, checkEmailSymbol } from '../utils/validators';
import ConfirmAuth from '../components/confirm-auth';

import { LANDING } from '../configs/api/api.config';
import { useAppSelector } from '../hooks/redux';
import { selectUser } from '../store/auth.slice';

const Login = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const userData = useAppSelector(selectUser);
  const [login] = useLoginMutation();
  const [isInputAuthCode, setIsInputAuthCode] = useState(false);
  const refEnter = useRef<HTMLButtonElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (userData) {
      navigate('/consultations');
    }
    // eslint-disable-next-line
  }, [userData]);

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      if (email.trim() === '') {
        toast.error('Введите Email');
        setError(' ');

        return;
      }
      const isEmail = checkEmailMask(email);
      if (!isEmail) {
        setError('Неверный формат Email');

        return;
      } else {
        setError('');
      }
      refEnter?.current?.click();
    }
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isCorrect = checkEmailSymbol(e.target.value);
    if (!isCorrect) {
      setEmail(e.target.value);
      setError('');
    }
  };

  const onBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (email.trim() === '') {
      setError(' ');

      return;
    }
    const isEmail = checkEmailMask(e.target.value);
    if (!isEmail) {
      setError('Неверный формат Email');
    } else {
      setError('');
    }
  };

  const onLogin = async () => {
    if (email.trim() === '') {
      setError('Введите email');

      return;
    }
    const isEmail = checkEmailMask(email);
    if (!isEmail) {
      setError('Неверный формат Email');

      return;
    }
    try {
      const authCode = await login({ email }).unwrap();

      if (authCode?.result) {
        setIsInputAuthCode(true);
      }
    } catch (e: any) {
      console.log(e);
      if (e.status === 422) {
        if (e.data.detail === 'Пользователь заблокирован') {
          toast.error(
            'Ваш аккаунт заблокирован, чтобы разблокировать, обратитесь к администратору сервиса info@zingizi.pro',
          );
        }
        setError(e.data.detail);
      }
    }
  };

  return (
    <div className="flex min-h-[calc(100dvh-50px)] w-screen items-center justify-center px-[15px] lg:min-h-[calc(100dvh-80px)]">
      {!isInputAuthCode ? (
        <div className="w-[420px] sm:w-[550px] max-h-[90%] overflow-y-auto rounded-popup bg-white short:p-[10px] p-[10px] md:p-[50px]">
          <div className="flex items-center text-center text-display-s md:text-display-l short:text-display-s mb-2.5">
            <BackButton className="-m-1.5" to={LANDING} />

            <span className="grow text-center">Вход</span>
          </div>
          <div className="text-center sm:px-[30px] short:px-[0px] text-ui md:text-body-l text-ink-muted mb-7 md:mb-10 short:mb-5">
            Войдите в аккаунт, чтобы получить доступ к личному кабинету
          </div>
          <div className="mb-7">
            <Input
              size="lg"
              label="Email"
              placeholder="Введите Email"
              error={error}
              value={email}
              onKeyDown={onKeyDown}
              onChange={onChange}
              onBlur={onBlur}
              autoComplete={'email'}
            />
          </div>
          <div className="mb-7 short:mb-5">
            <Button ref={refEnter} size="lg" fullWidth onClick={onLogin}>
              Войти
            </Button>
          </div>
          <div className="text-center">
            <div className="text-ui md:text-body-l text-ink-muted">Нет аккаунта?</div>
            <TextLink href="/registration" className="text-ui md:text-body-l">
              Зарегистрироваться
            </TextLink>
          </div>
        </div>
      ) : (
        <ConfirmAuth onBackToAuth={() => setIsInputAuthCode(false)} email={email} confirmCodex={false} />
      )}
    </div>
  );
};

export default Login;
